export default __webpack_public_path__ + "static/aboveheader-bg-06716424c605ebf96410f8275137414c.svg";